import { MedicalLeavePayer, MedicalLeavePayerForeignRecentlyApprovedQuery } from '@dreryk/egabinet-ezla-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { paginations } from '@dreryk/command-query-ws-client';
import { EmptyStatePlaceholder, RetryButton, StandardSpinner } from '@dreryk/react-components';

import { commonTranslationKeys } from '../../../../../translations';

type MedicalLeaveFormPayerSectionLoaderResult = {
   payersForeignRecentlyApproved: MedicalLeavePayer[];
};

type MedicalLeaveFormPayerSectionLoaderProps = {
   readonly patientId: number;
   readonly children: (result: MedicalLeaveFormPayerSectionLoaderResult) => JSX.Element;
};

export const MedicalLeaveFormPayerSectionLoader = (
   props: MedicalLeaveFormPayerSectionLoaderProps
): JSX.Element | null => {
   const {
      data: payersForeignRecentlyApproved,
      loading: payersForeignRecentlyApprovedLoading,
      error: payersForeignRecentlyApprovedError,
      refetch: refetchPayersForeignRecentlyApproved,
   } = useCqrsSearch<MedicalLeavePayer>(() => {
      const query = new MedicalLeavePayerForeignRecentlyApprovedQuery();
      query.patientId = props.patientId;
      return query;
   }, paginations.all());

   if (payersForeignRecentlyApprovedLoading) {
      return <StandardSpinner text={commonTranslationKeys.puePayersLoading} />;
   }

   if (payersForeignRecentlyApprovedError) {
      return (
         <>
            <EmptyStatePlaceholder heading={commonTranslationKeys.couldNotFetchPayers} testId={'couldNotFetchPayers'}>
               <RetryButton onClick={refetchPayersForeignRecentlyApproved} testId='retry' />
            </EmptyStatePlaceholder>
         </>
      );
   }

   return props.children({
      payersForeignRecentlyApproved: payersForeignRecentlyApproved,
   });
};
